import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [];

const FacturaPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Facturas</PageTitle>
      <View />
    </>
  );
};

export { FacturaPage };
